/* global axios */

class DealProductsAPI {
  get(accountId, dealId) {
    return axios.get(`/api/v1/accounts/${accountId}/deals/${dealId}/products`);
  }

  create(accountId, dealId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/deals/${dealId}/products`, {
      deal_product: payload,
    });
  }

  update(accountId, dealId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/deals/${dealId}/products/${id}`, {
      deal_product: payload,
    });
  }

  delete(accountId, dealId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/deals/${dealId}/products/${id}`);
  }
}

export default new DealProductsAPI();
